import { defineMessages } from 'react-intl';

export default defineMessages({
	emptyStateDescription: {
		defaultMessage:
			'All your portals are hidden from the home page. Select Topics and portals from the avatar menu to manage your portals.',
		description: 'Description message for portals empty state',
		id: 'hc.customization.list-of-portals.empty-state-description',
	},
	emptyStatePortalsDescription: {
		defaultMessage:
			'All your portals are hidden from the home page. Select <b>Customize,</b> then <b>Manage topics and portals</b> from the navigation to manage your portals.',
		description: 'Description message for portals empty state',
		id: 'hc.customization.list-of-portals.empty-state-portals-description',
	},
});
